import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandGroupListPage_UpdateBrandGroup(
    $brandGroupId: Int!
    $name: String!
  ) {
    updateBrandGroup(brandGroupId: $brandGroupId, input: { name: $name }) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useUpdateBrandGroupMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (variables) => graphQLRequest({ document, variables }),
    ...options,
  })
}
